import { render } from "./SaleItemSummary.vue?vue&type=template&id=21107ca9&scoped=true"
import script from "./SaleItemSummary.vue?vue&type=script&lang=js"
export * from "./SaleItemSummary.vue?vue&type=script&lang=js"

import "./SaleItemSummary.vue?vue&type=style&index=0&id=21107ca9&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21107ca9"]])

export default __exports__